import {useState} from "react"
import * as Yup from "yup";
import { Box, FormControl, FormHelperText, FormLabel, InputAdornment, TextField, Typography } from "@mui/material";
import { useRef } from "react";
import { ChatInfoIcon, SendMessageIcon } from "../../../assets/CommonSvg";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import FormikControl from "../../../components/common/FormikControl";
import { createChatRoom, selectAllPatientList, selectAllPhaseList } from "../../../slices/chat";
// import { useSocketInstance } from "../../../../context/SocketContext";

const validationSchema = Yup.object().shape({
    patient_id: Yup.number()
        .typeError("Patient must be a number")
        .required("Patient is required")
        .nullable(),
    phase_id: Yup.number()
        .typeError("Phase must be a number")
        .required("Phase is required")
        .nullable(),
    message: Yup.string().required("Please enter the message")
});

const NewChatGroup = ({
    setChatView,
    setSelectedRoom
}) => {
    const dispatch = useDispatch()
    // const { socketInstance } = useSocketInstance();
    const phaseList = useSelector(selectAllPhaseList)
    const patientList = useSelector(selectAllPatientList)
   const [isSubmitted, setIsSubmitted] = useState(false)
    const inputRef = useRef(null);
    const initialValues = {
        patient_id: null,
        phase_id: null,
        message: ""
    };

    const handleSendMessage = async () => {
        setIsSubmitted(true)
        // Mark all fields as touched to show errors if any
        formik.setTouched({
            patient_id: true,
            phase_id: true,
            message: true
        });

        if (!formik.isValid) return;

        if (formik.values?.patient_id && formik.values?.phase_id && formik.values?.message) {
            try {

                const response = await dispatch(createChatRoom({
                    ...formik?.values,
                    message_type: 1,
                    media_id: []
                })).unwrap()
                if (response?.status == 200) {
                    setChatView("chat");
                    setSelectedRoom(response?.data)
                    setIsSubmitted(false)
                    // if (socketInstance) {
                    //     let data = {
                    //         chat_room_id: response?.data?.id,
                    //         mentions: [],
                    //         name: response?.data?.name,
                    //         message: formik?.values?.message,
                    //         media_id: [],
                    //         message_type: 1
                    //     }
                    //     socketInstance.emit("send_room_message", data);
                    // }
                }
            } catch (err) {
                console.error(err);
                setIsSubmitted(false)
            }
        }
    };

    const handleSubmit = async () => {}

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })

    const handleInputChange = (e) => {
        const value = e.target.value;
        formik.setFieldValue("message", value)
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    };

    const formOptions = [
        {
            label: 'Select Phase',
            type: 'select',
            name: 'phase_id',
            placeholder: "Select Phase",
            options: phaseList.filter((item, index, self) =>
                index === self?.findIndex((t) => t.value === item.value && t.label === item.label)
            ),
            onChange: (e) => {
                formik.setFieldValue('patient_id', null)
                formik.handleChange(e);
            }
        },
        {
            label: 'Select Patient',
            type: 'select',
            name: 'patient_id',
            placeholder: "Select Patient",
            options: patientList.filter(op => op.phase_id == formik?.values?.phase_id),
        },
    ];

    return (
        <form onSubmit={formik.handleSubmit} className="flex flex-col overflow-hidden">
            <div className="flex-1 overflow-y-auto bg-white">
                <div className=" bg-white px-4 py-6">
                    {/* Top Section: Empty Chat State */}
                    <div className="flex flex-col items-center justify-center flex-grow">
                        <ChatInfoIcon />
                        <Typography className="mt-4 p-2 bg-yellow-100 text-black rounded-md text-xs shadow-none border-none ">
                            Select Phase and Patient, then type a message to initiate a group chat.
                        </Typography>

                        {/* Select Fields */}
                        <div className="mt-6 w-full max-w-sm space-y-4">
                            {formOptions.map((props, key) => {
                                const { label, ...restProps } = props;
                                return (
                                    <div key={key}>
                                        <FormControl
                                            variant={props.variant ?? "standard"}
                                            fullWidth={props.fullWidth ?? true}
                                            className={props.className}
                                        >
                                            {/* Field labels */}
                                            {label && (
                                                <FormLabel
                                                    className="block text-sm font-medium"
                                                    shrink
                                                    required={props.required}
                                                >
                                                    {label}
                                                </FormLabel>
                                            )}
                                            <FormikControl
                                                formik={formik}
                                                {...restProps}
                                                disabled={props?.disabled}
                                            />
                                            {/* {formik.touched[props.name] && formik.errors[props.name] && (
                                                <FormHelperText error>{formik.errors[props.name]}</FormHelperText>
                                            )} */}
                                        </FormControl>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100 mt-[1.5rem]">
                {formik.touched.message && formik.errors.message && (
                    <FormHelperText className="p-1" error>{formik.errors.message}</FormHelperText>
                )}
                <Box
                    className={`flex ${formik.touched.message && formik.errors.message ? "!border-2 border-red-300 rounded-bl-lg rounded-br-lg" : "border-0"}`}
                >
                    <TextField
                        inputRef={inputRef}
                        variant="outlined"
                        className="bg-[#F0F1F5] w-full py-[0.9rem] border-0 "
                        size="small"
                        name="message"
                        placeholder="Type something here..."
                        value={formik.values.message}
                        onChange={handleInputChange}
                        onBlur={formik.handleBlur}
                        onKeyPress={handleKeyPress}
                        sx={{ "& fieldset": { border: 'none' } }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end" className="flex gap-2 items-center">
                                    <button
                                        type="submit"
                                        disabled={isSubmitted}
                                        className="cursor-pointer"
                                        onClick={handleSendMessage}
                                    >
                                        <SendMessageIcon className="text-gray-500" />
                                    </button>
                                </InputAdornment>
                            )
                        }}
                    />
                </Box>
            </div>
        </form>
    );
};

export default NewChatGroup;